// Libraries
import LazyLoad from 'vanilla-lazyload';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/styles';

// Components
import initConstruction from '@components/cbb/construction';
import initPreloader from '@components/cbb/preloader';
import initBanner from '@components/cbb/banner';

document.addEventListener('DOMContentLoaded', function () {
  const lazyLoadInstance = new LazyLoad();
  const loadedSections = new WeakSet();

  const sections = [
    {
      element: document.querySelector('.cbb-about'),
      load: () => import('@components/cbb/about').then(({ default: init }) => init()),
    },
    {
      element: document.querySelector('.cbb-advantages'),
      load: () => import('@components/cbb/advantages').then(({ default: init }) => init()),
    },
    {
      element: document.querySelector('.cbb-map'),
      load: () => import('@components/cbb/map').then(({ default: init }) => init()),
    },
    {
      element: document.querySelector('.cbb-plannings'),
      load: () => import('@components/cbb/information').then(({ default: init }) => init()),
    },
    {
      element: document.querySelector('.cbb-contact-form'),
      load: () => Promise.resolve().then(() => initializeFormBlock()),
    },
    {
      element: document.querySelector('.cbb-gallery'),
      load: () => import('@components/cbb/gallery').then(({ default: init }) => init()),
    },
    {
      element: document.querySelector('.cbb-news'),
      load: () => import('@components/cbb/news').then(({ default: init }) => init()),
    },
    {
      element: document.querySelector('.cbb-s-projects'),
      load: () => import('@components/cbb/similar-projects').then(({ default: init }) => init()),
    },
  ];

  const initializeSection = sectionConfig => {
    if (!sectionConfig.element || loadedSections.has(sectionConfig.element)) {
      return;
    }

    loadedSections.add(sectionConfig.element);
    sectionConfig
      .load()
      .catch(() => {
        // Failed chunk load should not break the whole page initialization.
      });
  };

  sections.forEach(section => {
    if (section.element) {
      section.element.classList.add('lazy-load');
    }
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            return;
          }

          const sectionConfig = sections.find(({ element }) => element === entry.target);
          if (sectionConfig) {
            initializeSection(sectionConfig);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '150px 0px',
        threshold: 0.1,
      }
    );

    sections.forEach(section => {
      if (section.element) {
        observer.observe(section.element);
      }
    });
  } else {
    sections.forEach(initializeSection);
  }

  initPreloader();
  initBanner();
  initMobileNavigationButtons();
  initMobileMenu();

  // Yielding
  // This is needed to avoid main thread blocking
  setTimeout(() => {
    initializeOtherForms();
    initConstruction();
    initPopups();
    initLegalInfo();
  }, 0);
})

function initializeIti(inputElement) {
  return intlTelInput(inputElement, {
      showFlags: false,
      separateDialCode: true,
      initialCountry: "ua",
      loadUtilsOnInit: () => import("intl-tel-input/utils"),
      strictMode: true,
  });
}

/*Form block*/
function initializeFormBlock() {
  const formBlock = document.querySelector(".contact-us");
  const form = formBlock ? formBlock.querySelector(".contact-form") : null;

  if (form) {
      const phoneNumberInput = form ? form.querySelector('input[type="tel"]') : null;
      const hiddenPhone = form.querySelector('input[name="user-phone"]') || null;
      const formSuccessMessage = document.querySelector('.contact-us__success');
      let iti = initializeIti(phoneNumberInput);

      phoneNumberInput.addEventListener('input', function () {
          var inputValue = phoneNumberInput.value.replace(/\D/g, '');
          phoneNumberInput.value = inputValue;
          if (hiddenPhone) {
            hiddenPhone.value = iti.getNumber();
          }
      });

      form.addEventListener("submit", function (event) {
          event.preventDefault();

          let phoneNumber = phoneNumberInput.value;

          if (iti) {
              if (!iti.isValidNumber()) {
                  alert("Будь ласка, введіть коректний номер.");
                  return;
              } else {
                  phoneNumber = iti.getNumber();
              }
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              event: 'formSubmission',
              formName: 'Бажаєте дізнатись ціну?',
              formPosition: 'Contact block',
              referer: document.referrer || window.location.href,
              utm: window.location.search,
              phone_number: phoneNumber || 'undefined',
          });



          const getValue = name => form.querySelector(`input[name="${name}"]`)?.value || '';

          const utm = {
              utm_source: getValue('utm_source'),
              utm_medium: getValue('utm_medium'),
              utm_campaign: getValue('utm_campaign'),
              utm_term: getValue('utm_term'),
              utm_content: getValue('utm_content'),
          };


          fetch(`${window.location.origin}/wp-json/system/sendMessageToBot`, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                  form_name: "Бажаєте дізнатись ціну?",
                  phone_number: phoneNumber,
                  utm: utm,
                  site_url: window.location.origin + window.location.pathname,
                  gclid: getValue("gclid") || new URLSearchParams(window.location.search).get("gclid") || "",
              }),
          })
              .then(response => response.json())
              .then(data => {
                  formBlock.style.display = "none";
                  formSuccessMessage.style.display = "flex";
              })
              .catch(error => {
                  // Error handling
              });
      });
  }
}

/*Other forms*/
function initializeOtherForms() {
  const form = document.querySelectorAll(".blago-form");
  if (form) {
      form.forEach(form => {
          const formBlock = form.closest('.blago-form-block');
          const formMain = formBlock.querySelector('.blago-form-main');
          const formSuccessMessage = formBlock.querySelector('.blago-form-message');
          const formErrorMessage = formBlock.querySelector('.blago-form-error');
          const formName = formBlock.getAttribute('data-form-name');
          const nameInput = formBlock.querySelector("input[name='your-name']");
          const emailInput = formBlock.querySelector("input[name='your-email']");
          const phoneNumberInput = formBlock.querySelector("input[name='phone']");
          const positionInput = formBlock.querySelector("input[name='position']");
          const complexInput = formBlock.querySelector("input[name='complexes']");
          const messageInput = formBlock.querySelector("textarea[name='message']");
          const isPopup = form.closest('.popup') ? true : false;
          const popupType = isPopup ? form.getAttribute('data-popup-type') : 'undefined';
          const itiPhoneNumberInput = formBlock.querySelector("input[name='user-phone']");

          let iti;
          if (phoneNumberInput) {
              iti = initializeIti(phoneNumberInput);
              phoneNumberInput.addEventListener('input', function () {
                  var inputValue = phoneNumberInput.value.replace(/\D/g, '');
                  phoneNumberInput.value = inputValue;
                  itiPhoneNumberInput.value = iti.getNumber();
              });
          }

          form.addEventListener("submit", function (event) {
              event.preventDefault();
              const getValue = name => form.querySelector(`input[name="${name}"]`)?.value || '';

              formErrorMessage.textContent = "";

              const formData = {
                  utm: {
                      utm_source: getValue('utm_source'),
                      utm_medium: getValue('utm_medium'),
                      utm_campaign: getValue('utm_campaign'),
                      utm_term: getValue('utm_term'),
                      utm_content: getValue('utm_content'),
                  },
                  gclid: getValue("gclid") || new URLSearchParams(window.location.search).get("gclid") || ""
              };
              if (formName) {
                  formData['form_name'] = formName;
              }
              if (nameInput && nameInput.value) {
                  formData['client_name'] = nameInput.value;
              }
              if (emailInput && emailInput.value) {
                  formData['client_email'] = emailInput.value;
              }
              if (phoneNumberInput && phoneNumberInput.value) {
                  formData['phone_number'] = iti ? iti.getNumber() : phoneNumberInput.value;
              }
              if (positionInput && positionInput.value) {
                  formData['position'] = positionInput.value;
              }
              if (complexInput && complexInput.value) {
                  formData['interest_projects'] = complexInput.value;
              }
              if (messageInput && messageInput.value) {
                  formData['message'] = messageInput.value;
              }
              formData['site_url'] = window.location.origin + window.location.pathname;


              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                  event: 'formSubmission',
                  formName: formName,
                  formPosition: form.getAttribute('data-form-position') || 'undefined',
                  referer: document.referrer || window.location.href,
                  utm: window.location.search,
                  isPopup: isPopup,
                  popupType: popupType,
                  client_name: formData['client_name'] || 'undefined',
                  client_email: formData['client_email'] || 'undefined',
                  phone_number: formData['phone_number'] || 'undefined',
                  interest_projects: formData['interest_projects'] || 'undefined',
                  message: formData['message'] || 'undefined'
              });
              

              if (phoneNumberInput && !iti.isValidNumber()) {
                  if (formErrorMessage) {
                    formErrorMessage.textContent = 'Будь ласка, введіть коректний номер.';
                    formErrorMessage.style.display = "";
                  } else {
                    alert("Будь ласка, введіть коректний номер.")
                  }
              } else {
                  fetch(`${window.location.origin}/wp-json/system/sendMessageToBot`, {
                      method: "POST",
                      headers: {
                          "Content-Type": "application/json",
                      },
                      body: JSON.stringify(formData),
                  })
                      .then(response => response.json())
                      .then(data => {
                          form.style.height = 'auto';
                          formMain.style.display = "none";
                          formSuccessMessage.style.display = "flex";
                      })
                      .catch(error => {
                          // Error handling
                      });
              }
          });

          form.addEventListener('reset', function () {
              if (iti && typeof iti.destroy === 'function') {
                  iti.destroy();
              }
              if (phoneNumberInput) {
                  iti = initializeIti(phoneNumberInput);
              } else {
                  iti = undefined;
              }
          });
      });
  }
}

/*Popups*/
function initPopups() {
  document.querySelectorAll('[data-cbb-popup]').forEach(trigger => {
    trigger.addEventListener('click', function (e) {
      if (this.closest('.cbb-popup')) {
        return;
      }

      const target = this.getAttribute('data-cbb-popup');
      const popup = document.querySelector(`.cbb-popup[data-cbb-popup="${target}"]`);
      if (popup) {
        popup.classList.add('active');
      }
    });
  });


  document.querySelectorAll('.cbb-popup__close').forEach(closeBtn => {
    closeBtn.addEventListener('click', function () {
      const popup = this.closest('.cbb-popup');
      if (popup) {
        popup.classList.remove('active');
      }
    });
  });

  document.querySelectorAll('.cbb-popup').forEach(popup => {
    popup.addEventListener('click', function (e) {
      if (e.target === this) {
        this.classList.remove('active');
      }
    });
  });
}

/*Mobile navigation buttons*/
function initMobileNavigationButtons() {
  const handleScroll = function () {
    if ($(window).scrollTop() > 0) {
      $('.buttons-for-mobile').addClass('buttons-for-mobile--visible')
    } else {
      $('.buttons-for-mobile').removeClass('buttons-for-mobile--visible')
    }
  };

  if ($('.buttons-for-mobile').length) {
    handleScroll()
    $(window).on('scroll', handleScroll);
  }
}

/*Mobile menu*/
function initMobileMenu() {
  $('.menu__icon-wrapper').on('click', function () {
    $(this).toggleClass('menu__cross-icon-wrapper')
    $(this).siblings().find('.bm-menu').toggleClass('active')
  })
  $('.menu .section__link.menu__link.dropdown-title').on('click', function () {
    $(this).siblings('.dropdown__list').toggleClass('dropdown__list--visible')
  })
}

/* Legal information */
function initLegalInfo() {
  const legalInformation = document.querySelector('.legal-information');

  if (!legalInformation) return;

  const button = legalInformation.querySelector('.legal-information__show');
  const rows = legalInformation.querySelector('.legal-information__rows');

  if (!button || !rows) return;

  let isActive = false;

  button.addEventListener('click', () => {
    isActive = !isActive;

    rows.style.display = isActive ? '' : 'none';
    button.textContent = isActive ? button.getAttribute('data-active') : button.getAttribute('data-inactive');
  });
}